/* eslint-disable @typescript-eslint/no-misused-promises */
/**
 * Forgot password form
 */

import {
  Button,
  Heading,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  VStack,
  useToast,
} from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import TextField from "components/base/atoms/TextField";
import { useForm } from "react-hook-form";
import { setFormErrors } from "utils";
import { useForgotPasswordQuery } from "../../_actions/AuthActions";
import { ForgotPasswordSchema } from "../../config/schema/ForgotPasswordSchema";
import { ModalTypes } from "../../config/types/modals";
import useAuth from "../../hooks/useAuth";
import { SecondaryButton } from "../base/atoms/HJSButton";
import {
  ErrorToastHandler,
  SuccessToastHandler,
} from "components/helpers/ToastHelpers";

interface IForgotPasswordValues {
  email: string;
}
interface IModalComponentProps {
  changeModalType: (modalType: ModalTypes) => void;
}
type TModalComponent = (props: IModalComponentProps) => JSX.Element;

const ForgotPassword: TModalComponent = ({
  changeModalType,
}: IModalComponentProps) => {
  const toast = useToast();
  const { setAuthState } = useAuth();

  const initialFormValues: IForgotPasswordValues = {
    email: "",
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    setError,
  } = useForm<IForgotPasswordValues>({
    resolver: yupResolver(ForgotPasswordSchema),
    defaultValues: initialFormValues,
  });

  const { mutate: forgotPassword, isLoading } = useForgotPasswordQuery();

  const submitHandler: (values: IForgotPasswordValues) => void = (
    values: IForgotPasswordValues
  ) => {
    void (async () => {
      forgotPassword(
        {
          email: values.email,
        },
        {
          onSuccess: () => {
            setAuthState({ email: values.email });
            SuccessToastHandler({
              toast,
              title: "Success! 🎉",
              description: "We've sent a verification code to your email",
            });
            changeModalType(ModalTypes.CONFIRM_FORGOT_PASSWORD);
          },
          onError: (error) => {
            setFormErrors(error, setError);
            ErrorToastHandler({
              toast,
              title: "Error",
              description:
                "Some error occurred while sending verification code to your email",
            });
          },
        }
      );
    })();
  };

  return (
    <ModalContent px={{ base: 0, md: 6 }} py={4}>
      <form onSubmit={handleSubmit(submitHandler)}>
        <ModalHeader>
          <Heading as="h2" fontSize={[20, 20, 30, 40]} color="teal.900">
            Forgot Password?
          </Heading>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack my={10} alignItems="flex-start">
            <TextField
              label="Email"
              placeholder="Enter your email"
              type="text"
              error={Boolean(errors.email)}
              helperText={errors.email?.message}
              {...register("email")}
            />
          </VStack>
        </ModalBody>
        <ModalFooter alignItems="center" justifyContent="center">
          <VStack>
            <SecondaryButton
              my={4}
              type="submit"
              px={16}
              isLoading={isLoading}
              fontSize={[14, 14, 16]}
            >
              Send link
            </SecondaryButton>
            {/* <Button
              fontWeight="400"
              color="hjsBlack"
              variant="link"
              fontSize={[14, 14, 16]}
              onClick={() => changeModalType(ModalTypes.LOGIN)}
            >
              Go Back
            </Button> */}
          </VStack>
        </ModalFooter>
      </form>
    </ModalContent>
  );
};

export default ForgotPassword;
